import { shouldShowPreRegistrationSteps } from "@/lib/affiliation"
import { useInfoLoginData } from "@/services"

export function useAffiliationDetection() {
  const data = useInfoLoginData()
  return data != null ? shouldShowPreRegistrationSteps(data) : false
}
